import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import { FuseSharedModule } from '@fuse/shared.module';

import { LoginComponent } from './login.component';

// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import { AutenticacionComponent } from './autenticacion/autenticacion.component';
// import { LoadingComponent } from './loading/loading.component';

const routes = [
    {
        path     : 'login',
        component: LoginComponent
    }
    // {
    //     path     : 'loading/:id',
    //     component: LoadingComponent
    // }
];

@NgModule({
    declarations: [
        LoginComponent,
        AutenticacionComponent,
        // LoadingComponent
    ],
    imports     : [
        RouterModule.forChild(routes),

        MatButtonModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressBarModule,
        MatSelectModule,
        MatStepperModule,
        MatCardModule,
        MatDialogModule,
        MatTooltipModule,
        MatProgressSpinnerModule,

        FuseSharedModule,
        TranslateModule
    ],
    entryComponents: [AutenticacionComponent]
})
export class LoginModule
{
}
